import { AgGridTable, type CustomColDef } from '@shared/components/ui/AgGridTable';
import type { BankAccount } from '../../models/BankAccount';

interface BankAccountsAgGridTableProps {
  bankAccounts: BankAccount[];
  columnDefs: CustomColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

// Copiado del patrón de Wallets/List para asegurar consistencia visual
export const BankAccountsAgGridTable = ({
  bankAccounts,
  columnDefs,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
}: BankAccountsAgGridTableProps) => {
  return (
    <AgGridTable
      data={bankAccounts}
      columnDefs={columnDefs}
      height="calc(100vh - 150px)"
      rowHeight={64}
      enableSelection={false}
      suppressAggFuncInHeader={true}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
    />
  );
};
